import { TextureData } from "../../../types/types";
import { ISize } from "../../../controls/scrollpane/ISize";
import { RectSize } from "../../../utils/RectSize";
import { SettingsItem } from "../options/SettingsItem";
import { LoaderFileKeys } from "../../constant/AppConstants";


/**
 * Yellow label item on gray/black background as header 
 * with 3 titles/labels on top of (one of the) results page/content table(s)
 */
export class ResultsHeaderItem
    extends SettingsItem
    implements ISize {
    public label2: Phaser.GameObjects.Text;
    public label3: Phaser.GameObjects.Text;

    protected bgTextureData: TextureData;
    protected labelTextStyle: Phaser.Types.GameObjects.Text.TextStyle;

    /**
     * @see ResultsListItem::bubbleWidth
     */
    protected referenceItemWidth: number = 197;

    // delimiter line
    public imgDelimiterLine: Phaser.GameObjects.Image;
    protected delimiterLineAlpha: number;


    public Init(
        bgTextureData: TextureData = undefined,
        labelTextStyle: Phaser.Types.GameObjects.Text.TextStyle = undefined,
        delimiterLineAlpha: number,
    ): void {
        this.bgTextureData = bgTextureData;
        this.labelTextStyle = labelTextStyle;
        this.delimiterLineAlpha = delimiterLineAlpha;

        this.size = new RectSize();
    }

    public Build(): void {
        this.bg = this.scene.make.image({ x: 0, y: 0, key: this.bgTextureData.texture, frame: this.bgTextureData.frame });
        this.bg.setOrigin(0);
        this.add(this.bg);

        this.label = this.scene.make.text({ style: this.labelTextStyle });
        this.label.setOrigin(0, 0.5);
        this.add(this.label);

        this.label2 = this.scene.make.text({ style: this.labelTextStyle });
        this.label2.setOrigin(0.5);
        this.add(this.label2);

        this.label3 = this.scene.make.text({ style: this.labelTextStyle });
        this.label3.setOrigin(0.5);
        this.add(this.label3);

        this.imgDelimiterLine = this.scene.make.image({ key: LoaderFileKeys.ui, frame: "rect-2x2-white.png" });
        this.imgDelimiterLine.setOrigin(0, 0.5);
        this.imgDelimiterLine.alpha = this.delimiterLineAlpha;
        this.add(this.imgDelimiterLine);
    }

    public SetData(
        label: string = undefined,
        label2: string = undefined,
        label3: string = undefined,
    ): void {
        this.label.text = label;
        this.label2.text = label2;
        this.label3.text = label3;
    }

    /**
     * @alike: OnResize
     * Uses 'maximum allowed width' to compute item's resulting height
     * - Item's width and height depends on height of label textfield
     * - label's height depends on amount of HORIZONTAL space and maximum horizontal space allowed for item
     * 
     * @param width 
     */
    public override SetWidthGetHeight(width: number): number {
        const totalSpacePerElement = width / 3;
        this.label.style.setWordWrapWidth(totalSpacePerElement);
        this.label2.style.setWordWrapWidth(totalSpacePerElement);
        this.label3.style.setWordWrapWidth(totalSpacePerElement);

        const highestLabelDisplayHeight = Math.max(this.label.displayHeight, this.label2.displayHeight, this.label3.displayHeight)

        // computes and returns height
        return highestLabelDisplayHeight + 2 * this.borderPadding.vertical;
    }

    public override OnResize(): void {
        this.bg.setDisplaySize(this.size.width, this.size.height);
        // origin 0,1 (bot left)
        this.imgDelimiterLine.y = this.size.height;
        this.imgDelimiterLine.displayWidth = this.size.width;
        // label origin (0, 0.5)
        this.label.setPosition(this.borderPadding.horizontal, this.size.height / 2);
        // label origin (0.5, 0.5)
        this.label2.setPosition(this.size.width / 2, this.size.height / 2);
        // label origin (1, 0.5)
        this.label3.setPosition(this.size.width - this.borderPadding.horizontal - this.referenceItemWidth * 0.5, this.size.height / 2);
    }
}